import type { Media } from '@/types/media';
import MediaCard from '@/components/base/MediaCard';

interface MediaGridProps {
  items: Media[];
  columns?: 3 | 4;
  variant?: 'grid' | 'list';
}

export default function MediaGrid({ items, columns = 4, variant = 'grid' }: MediaGridProps) {
  if (variant === 'list') {
    return (
      <div className="flex flex-col gap-3">
        {items.map((item) => (
          <MediaCard key={item.id} media={item} variant="list" />
        ))}
      </div>
    );
  }

  const gridClass =
    columns === 3
      ? 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-5'
      : 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5';

  return (
    <div className={gridClass}>
      {items.map((item) => (
        <MediaCard key={item.id} media={item} />
      ))}
    </div>
  );
}